<template>
  <nt-template>
    <v-row dense justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card>
          <v-card-text class="text-center">
            <h3 class="text-h5 mt-4 mb-0 text-center">
              Nova Matrícula
            </h3>
            <h4 v-if="unit">
              Unidade {{ unit.name }}
            </h4>
          </v-card-text>
          <v-card-text>
            <router-view/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </nt-template>
</template>

<script>
import { Unit } from '@/services/resources'
import NtTemplate from '@/components/Utils/NtTemplate'

export default {
  mounted () {
    Unit.show(this.$route.params.unit).then((response) => {
      this.unit = response.body
    })
  },
  components: {
    NtTemplate
  },
  data () {
    return {
      unit: null
    }
  }
}
</script>
